import React, { useState } from "react";
import styles from "./AssetsLiabilities.module.css";

function AssetsLiabilities({ formData, setFormData }) {
  const [rows, setRows] = useState(
    formData.assetsLiabilities || [
      { type: "Asset", category: "Savings", owner: "Applicant 1", value: "" },
    ]
  );

  const addRow = () => {
    const updated = [
      ...rows,
      { type: "Asset", category: "", owner: "", value: "" },
    ];
    setRows(updated);
    setFormData({ ...formData, assetsLiabilities: updated });
  };

  const removeRow = (index) => {
    const updated = [...rows];
    updated.splice(index, 1);
    setRows(updated);
    setFormData({ ...formData, assetsLiabilities: updated });
  };

  const updateRow = (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = value;
    setRows(updated);
    setFormData({ ...formData, assetsLiabilities: updated });
  };

  return (
    <div className={styles.container}>
      <h3>Assets & Liabilities</h3>

      <div className={styles.tableHeader}>
        <span>Type</span>
        <span>Category</span>
        <span>Owner</span>
        <span>Value / Balance</span>
        <span></span>
      </div>

      {rows.map((row, index) => (
        <div key={index} className={styles.row}>
          {/* Type */}
          <select
            value={row.type}
            onChange={(e) => updateRow(index, "type", e.target.value)}
          >
            <option value="Asset">Asset</option>
            <option value="Liability">Liability</option>
          </select>

          {/* Category */}
          <select
            value={row.category}
            onChange={(e) => updateRow(index, "category", e.target.value)}
          >
            <option value="">Select Category</option>
            {row.type === "Asset" ? (
              <>
                <option value="Savings">Savings</option>
                <option value="Property">Property</option>
                <option value="Superannuation">Superannuation</option>
                <option value="Shares">Shares</option>
                <option value="Other Asset">Other Asset</option>
              </>
            ) : (
              <>
                <option value="Credit Card">Credit Card</option>
                <option value="Personal Loan">Personal Loan</option>
                <option value="Car Loan">Car Loan</option>
                <option value="HECS/HELP">HECS/HELP</option>
                <option value="Home Loan">Home Loan</option>
                <option value="Other Debt">Other Debt</option>
              </>
            )}
          </select>

          {/* Owner */}
          <select
            value={row.owner}
            onChange={(e) => updateRow(index, "owner", e.target.value)}
          >
            <option value="">Select Owner</option>
            <option value="Applicant 1">Applicant 1</option>
            <option value="Applicant 2">Applicant 2</option>
            <option value="Joint">Joint</option>
          </select>

          {/* Value */}
          <input
            type="number"
            placeholder="$"
            value={row.value}
            onChange={(e) => updateRow(index, "value", e.target.value)}
          />

          {/* Remove */}
          <button
            className={styles.removeBtn}
            onClick={() => removeRow(index)}
          >
            ×
          </button>
        </div>
      ))}

      <button className={styles.addBtn} onClick={addRow}>
        + Add Asset / Liability
      </button>
    </div>
  );
}

export default AssetsLiabilities;
